import { Helmet } from "react-helmet-async";
// @mui
import { Container, Typography } from "@mui/material";
import BankingMenu from "../sections/@dashboard/banking/BankingMenu";
import CreateSettingsFirst from "../sections/@dashboard/banking/CreateSettingsFirst";
import { useGetBankingAccountsQuery } from "../features/banking/bankingApiSlice";

// ----------------------------------------------------------------------

export default function BankingPage() {
  const { data: accounts = [] } = useGetBankingAccountsQuery();

  return (
    <>
      <Helmet>
        <title> MA | Banking </title>
      </Helmet>

      <Container maxWidth="xl">
        <Typography variant="h4" textAlign={"left"} sx={{ mb: 5 }}>
          Banking & SEPA
        </Typography>

        {accounts && accounts?.length > 0 ? (
          <BankingMenu />
        ) : (
          // <SepaForm />
          <CreateSettingsFirst />
        )}
      </Container>
    </>
  );
}
